import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import GlemtPassord from "@/pages/GlemtPassord";
import TilbakestillPassord from "@/pages/TilbakestillPassord";
import PreVote from "@/pages/PreVote";
import SigneringRetur from "@/pages/SigneringRetur";
import ExternalSign from "@/pages/ExternalSign";
import Admin from "@/pages/Admin";
import Dashboard from "@/pages/Dashboard";
import Portfolio from "@/pages/Portfolio";
import Profile from "@/pages/Profile";
import DashboardList from "@/pages/DashboardList";
import { MarketingLayout } from "@/components/marketing/MarketingLayout";
import Landing from "@/pages/marketing/Landing";
import Funksjoner from "@/pages/marketing/Funksjoner";
import Nokkeltall from "@/pages/marketing/Nokkeltall";
import Sikkerhet from "@/pages/marketing/Sikkerhet";
import ForHvem from "@/pages/marketing/ForHvem";
import Priser from "@/pages/marketing/Priser";
import Om from "@/pages/marketing/Om";
import Kontakt from "@/pages/marketing/Kontakt";
import { AppShell } from "@/components/layout/AppShell";
import Overview from "@/pages/company/Overview";
import Financials from "@/pages/company/Financials";
import Boardroom from "@/pages/company/Boardroom";
import MeetingDetail from "@/pages/company/MeetingDetail";
import ShareRegistry from "@/pages/company/ShareRegistry";
import EmissionSim from "@/pages/company/EmissionSim";
import Documents from "@/pages/company/Documents";
import ShareholderAgreementPage from "@/pages/company/ShareholderAgreementPage";
import Tasks from "@/pages/company/Tasks";
import Roles from "@/pages/company/Roles";
import Access from "@/pages/company/Access";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/glemt-passord" element={<GlemtPassord />} />
              <Route path="/reset-passord" element={<TilbakestillPassord />} />
              <Route path="/forhandsstemme/:meetingId/:shareholderId" element={<PreVote />} />
              <Route path="/signer/:token" element={<ExternalSign />} />
              <Route
                path="/signering-retur"
                element={
                  <ProtectedRoute>
                    <SigneringRetur />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route element={<MarketingLayout />}>
                <Route path="/" element={<Landing />} />
                <Route path="/funksjoner" element={<Funksjoner />} />
                <Route path="/nokkeltall" element={<Nokkeltall />} />
                <Route path="/sikkerhet" element={<Sikkerhet />} />
                <Route path="/for-hvem" element={<ForHvem />} />
                <Route path="/om" element={<Om />} />
                <Route path="/kontakt" element={<Kontakt />} />
                <Route path="/priser" element={<Priser />} />
              </Route>
              <Route
                path="/hjem"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/portefolje"
                element={
                  <ProtectedRoute>
                    <Portfolio />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profil"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/oversikt/:view"
                element={
                  <ProtectedRoute>
                    <DashboardList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/selskap/:companyId"
                element={
                  <ProtectedRoute>
                    <AppShell />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Overview />} />
                <Route path="nokkeltall" element={<Financials />} />
                <Route path="styrerom" element={<Boardroom />} />
                <Route path="moter/:meetingId" element={<MeetingDetail />} />
                <Route path="aksjehandbok" element={<ShareRegistry />} />
                <Route path="simulering" element={<EmissionSim />} />
                <Route path="dokumenter" element={<Documents />} />
                <Route path="aksjonaeravtale" element={<ShareholderAgreementPage />} />
                <Route path="oppgaver" element={<Tasks />} />
                <Route path="roller" element={<Roles />} />
                <Route path="tilgang" element={<Access />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-right" richColors closeButton />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
